import React from 'react';
import  { useState } from 'react';
import Ref from '../../helpers/Reference';
import { fillMCHS } from '../../helpers/helpers';

import { useStationFilter } from './store';

import { Space, Button, Checkbox, Popover, Radio } from 'antd';
import { Button as CustomButton } from "../Buttons/button";

import IcoMchs from '../../images/ico_mchs_filter.svg';
import IcoMchsActive from '../../images/ico_mchs_filter_active.svg';
import References from '../../helpers/Reference';

export const FilterStation = ({stations, startPos}) => {   

    const [ filter, setFilter ] = useState([]);
    const [ filterOrAnd, setOrAndFilter ] = useState( 'or' );
    const [ opened, setOpened ] = useState( false );
    
    const StationFilter = ( filter, orAnd ) => {        
        let mchsFilter = [];
        for ( let i in filter ) 
            mchsFilter = mchsFilter.concat(Ref.mchsFilter[filter[i]].filter);
        useStationFilter.setState({mchs: {items: mchsFilter, orAnd: orAnd}});
    }    
    
    const onChange = (e) => {
        let currFilter = filter;
        let checked = e.target.checked;
        let val = e.target.value;

        if (checked)
            currFilter.push( val );
        else {
            let index = currFilter.indexOf( val );
            if (index > -1)
                currFilter.splice( index, 1);
        } 
        setFilter( filter );                
        StationFilter( currFilter, filterOrAnd );
    }

    const onOrAndChange = ( e ) => {
        const orAnd = e.target.value;
        setOrAndFilter( orAnd );
        StationFilter( filter,  orAnd );
    }

    const onFilterClick = () => {
        StationFilter( filter, filterOrAnd );        
        setOpened( false );        
    }

    const onSelectAll = ( e ) => {
        const currFilter = Object.keys(Ref.mchsFilter).map(item => item);
        setFilter( currFilter ); 
        StationFilter( currFilter, filterOrAnd );
    }

    const onFilterClearClick = (e) => {
        const currFilter = [];
        const currCond = 'or';
        setFilter(currFilter);
        setOrAndFilter(currCond);
        StationFilter( currFilter, currCond );
    }

    const onOpenChange = (newOpened) => {
        setOpened(newOpened);
    };    

    const mchsFilterItems = () => {
        //из слоя актуальности достаем все доступные пользователю каналы
        const mchs = fillMCHS( stations );
        return Object.keys(Ref.mchsFilter).map((item) => {   
            //отфильтровываем доступный пользвователю набор каналов
            if ( Ref.mchsFilter[item].filter.filter(val => mchs.includes(val)).length > 0) {

                return (
                    <div className="mt-1 pv-1 borderb-eee" key={`mchs_filter_panel_${item}`}>
                        <Checkbox 
                            value={item} 
                            onChange={onChange} 
                            checked={filter.indexOf(item) !== -1}
                        >{Ref.mchsFilter[item].title}
                        </Checkbox>
                    </div>
                )            
            }
        })
    }

    const stationFilterContent = () => {
        const items = mchsFilterItems();
        return (
            <>
                <div className="pv-3">
                <span className="close" onClick={() => setOpened(false)}>&times;</span>                    
                    <Space className="text-center">
                        <Button type="default" onClick={onSelectAll}>{Ref.dictionary.select_all}</Button>
                        <Button type="default" onClick={onFilterClearClick}>{Ref.dictionary.reset_all}</Button>                                
                    </Space>
                    <div className="text-left mt-2">
                    <Radio.Group defaultValue="or" value={filterOrAnd} size="md" optionType="default" buttonStyle="outline" onChange={onOrAndChange}>
                        <Radio.Button value="or" checked={"or" === filterOrAnd}>{Ref.dictionary.or}</Radio.Button>
                        <Radio.Button value="and" checked={"and" === filterOrAnd}>{Ref.dictionary.and}</Radio.Button>
                    </Radio.Group>                            
                </div>               

                </div>

                {items}
            </>
        );
    }

    return (
        <div className="left-menu-items" style={{top: `${startPos + 60}px`}}>
        <Popover 
        trigger="click"
        open={opened}
        onOpenChange={onOpenChange} 
        placement="topRight"                   
        overlayClassName="popup-left-menu-padding"
        arrow={false}
        content={stationFilterContent} >
            <>
            <CustomButton
            id="filter_station_mch_btn"
            type="circle"
            icon={filter.length > 0 ? IcoMchsActive : IcoMchs}
            tooltip={{
                title: References.dictionary.tooltips.button_filter_station_mchs,
                placement: "left"
            }}
            size="md"                
            />
            </>
            </Popover>   
        </div>
    );
}


